/* eslint-disable quotes */
import React from 'react';
import TextStyle from '@rezdy/components/TextStyle';
import Button from '@rezdy/components/Button';
import { Title } from './Styled';
import { CONTACT_SUPPORT } from '../../constants/auth';
import { WithTranslation, withTranslation } from 'react-i18next';

export class VerifyEmailError extends React.PureComponent<WithTranslation> {
    handleOnClick = () => {
        window.open(CONTACT_SUPPORT, '_blank');
    };

    render(): React.ReactNode {
        const { i18n } = this.props;
        return (
            <React.Fragment>
                <Title>{i18n.t("We couldn't verify your email address")}</Title>
                <TextStyle as="p">
                    {i18n.t(
                        'We are having trouble verifying your email address. Please click the button below to raise a ticket so that our support team can help you.'
                    )}
                </TextStyle>
                <Button action="primary" onClick={this.handleOnClick} width="100%">
                    {i18n.t('Contact Support')}
                </Button>
            </React.Fragment>
        );
    }
}

export default withTranslation()(VerifyEmailError);
